// src/components/ErrorBoundary.tsx
import { datadogRum } from '@datadog/browser-rum';
import React, { Component, ComponentType } from 'react'

interface Props {
  fallback: ComponentType<{ error: Error; resetError: () => void }>
  children: React.ReactNode
}

interface State {
  error: Error | null
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    datadogRum?.addError(error, {
      source: 'react',
      componentStack: info.componentStack,
    })
  }

  resetError = () => {
    this.setState({ error: null })
  }

  render() {
    const { error } = this.state
    const { fallback: Fallback, children } = this.props

    if (error) return <Fallback error={error} resetError={this.resetError} />
    return children
  }
}